import { PageController } from '@client/components/_core/layout/PageController';
import { TimelineMilestoneOverlay } from '@client/components/_core/settings/timeline/TimelineMilestoneOverlay';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/console/$orgId/configuration/compliance/complaints/general/timeline/milestones/edit/$internalName',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Edit milestone',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <TimelineMilestoneOverlay entity="complaint" internalName={Route.useParams().internalName} />
        </PageController>
    );
}
